import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SettingsCtx = createContext({ settings: {}, refresh: () => {} });

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const assetUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return path;
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data || {});
      if (r.data?.page_title) document.title = r.data.page_title;
      if (r.data?.favicon_url) {
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = assetUrl(r.data.favicon_url);
      }
    } catch {}
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  return <SettingsCtx.Provider value={{ settings, refresh }}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
